// 登录、注册、公用接口
import request from '@/utils/request'

// 登录
export function signIn(username, password) {
  const data = {
    username,
    password,
    timestamp: Math.floor(+new Date() / 1000),
  }
  return request({
    url: '/market/auth/login',
    method: 'post',
    transformRequest: [
      function(oldData) {
        let newStr = ''
        for (const item in oldData) {
          newStr +=
            encodeURIComponent(item) +
            '=' +
            encodeURIComponent(oldData[item]) +
            '&'
        }
        newStr = newStr.slice(0, -1)
        return newStr
      },
    ],
    data,
  })
}

// 登出
export function signOut() {
  return request({
    url: '/market/auth/logout',
    method: 'delete',
  })
}

// 注册
export function signUp(data) {
  return request({
    url: '/market/login/register',
    method: 'post',
    data,
  })
}

// 获取验证码
export function fetchGetVerifyCodeByEmail(data) {
  return request({
    url: '/market/login/forget',
    method: 'put',
    data,
  })
}

// 验证码校验
export function fetchCheckVerifyCode(data) {
  return request({
    url: '/market/login/verifycodecheck',
    method: 'post',
    data,
  })
}

// 确认修改密码
export function fetchResetPassword(data) {
  return request({
    url: '/market/login/uppassword',
    method: 'post',
    data,
  })
}

// 获取所有国家列表
export function fetchAllCountriesList() {
  return request({
    url: '/fore/user/country',
    method: 'get',
  })
}

// 获取语言列表
export function fetchLanguageList() {
  return request({
    url: '/market/keywords/languagelist',
    method: 'get',
  })
}
